module.exports = __webpack_public_path__ + "img/icon_check_in.18160065.png";